import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../service/http-service";
import { StudentMasterEndpoint } from "../../service/endpointConfig/StudentMasterEndpoint";

let initialState: any = {
  studentMasterResponse: {
    sendLink: undefined,
  },
};

export interface Address {
  id: number | string;
  countryId: number | string;
  city?: number | string;
  pincode: number | string;
  stateId?: number | string;
  address1: string;
  address2: string;
}
export interface StudentMasterProps {
  id?: number;
  studentName: string;
  dateOfBirth: any;
  gender: string;
  schoolId: number | undefined;
  className: string;
  sourceOfEnquiry: string;
  sourceOfEnquiryId: number;
  referredById?: number | string;
  otherInfo?: string;
  parentName: string;
  primaryMobileNumber: string;
  whatsappMobileNumber: string;
  alternateMobileNumber?: string;
  email: string;
  primaryBenefitYouExpectId?: number | string;
  courseId: number;
  registeredDate: any;
  courseInstructorId: number | string;
  batchId: number | string;
  levelStartDate: any;
  levelEndDate?: any;
  levelStatusId: number;
  promoCodeId?: number | string;
  modeOfPaymentId: number | string;
  discountIfAny?: string;
  totalAmountToBePaid: string | number;
  registrationType: string;
  registrationTypeId: number | string;
  levelOfAdmissionId: undefined | string;
  receiptDate: any;
  countryId: number | undefined;
  pincode: number | undefined;
  state: string;
  city: string;
  address1: string;
  address2: string;
  address?: Address[];
  enquiryDate?: any;
  parentPaidDate?: any;
  active: string;
  franchiseeId: number;
  parentGstNumber?: string | number;
  studentCode?: number | string;
  tuitionFeesChecked: string;
  tuitionFeesType: string;
  oneTimeRegistrationFeeChecked: string;
  registrationKitId: number | string;
  feeMonth: any[];
  invoiceAmount: number | string;
  invoiceAmountAfterDiscount: number | string;
}

export const studentMasterService = createAsyncThunk(
  "master/studentMaster",
  async (studentMaster: any) => {
    try {
      let response;
      switch (studentMaster.apiAction) {
        case "list":
          response = await getAPI(
            `${StudentMasterEndpoint.studentList}?${studentMaster.queryParams}`
          );
          break;
        case "listById":
          response = await getAPI(
            `${StudentMasterEndpoint.student}/${studentMaster.formValues}`
          );
          break;
        case "viewById":
          response = await getAPI(
            `${StudentMasterEndpoint.student}/view/${studentMaster.formValues}`
          );
          break;
        case "assessmentScoreController":
          response = await getAPI(
            `${StudentMasterEndpoint.assessmentScoreController}/${studentMaster.selectedId}`
          );
          break;
        case "levelStatusChangeDiscontinue":
          response = await postAPI(
            `${StudentMasterEndpoint.levelStatusChangeDiscontinue}`,
            studentMaster.formValues
          );
          break;
        case "levelStatusChangeActive":
          response = await putAPI(
            `${StudentMasterEndpoint.levelStatusChangeActive}?studentId=${studentMaster?.formValues?.studentId}&activeDate=${studentMaster?.formValues?.activeDate}`
          );
          break;
        case "level_discontinue_confirmation_edit":
          response = await putAPI(
            `${StudentMasterEndpoint.level_discontinue_confirmation}`,
            studentMaster.formValues
          );
          break;
        case "getLevelDiscontinueConfirmation":
          response = await getAPI(
            `${StudentMasterEndpoint.level_discontinue_confirmation}/${studentMaster.selectedId}`
          );
          break;
        case "getJourney":
          response = await getAPI(
            `${StudentMasterEndpoint.journey}/${studentMaster.studentId}`
          );
          break;
        case "create":
          response = await postAPI(
            StudentMasterEndpoint.student,
            studentMaster.formValues
          );
          break;
        case "update":
          response = await putAPI(
            StudentMasterEndpoint.student,
            studentMaster.formValues
          );
          break;
        case "promoCode":
          response = await getAPI(StudentMasterEndpoint.promoCode);
          break;
        case "course":
          response = await getAPI(StudentMasterEndpoint.course);
          break;
        case "ci_name":
          response = await getAPI(StudentMasterEndpoint.ci_name);
          break;
        case "batch_name":
          response = await getAPI(StudentMasterEndpoint.batch_name);
          break;
        case "batchDropdownByInstructorId": {
          const requestParams = studentMaster.courseId
            ? `?ciId=${studentMaster.instructorId}&courseId=${studentMaster.courseId}`
            : `?ciId=${studentMaster.instructorId}`;
          response = await getAPI(
            `${StudentMasterEndpoint.batch_name}${requestParams}`
          );
          break;
        }
        case "level_name":
          response = await getAPI(
            `${StudentMasterEndpoint.level_name}/${studentMaster?.courseId}/${StudentMasterEndpoint.level_name}`
          );
          break;
        case "courseLevel":
          response = await getAPI(StudentMasterEndpoint.level_name);
          break;
        case "sendLink":
          response = await postAPI(
            StudentMasterEndpoint.sendLink,
            studentMaster.formValues
          );
          break;
        case "delete":
          response = await deleteAPI(
            `${StudentMasterEndpoint.student}/${studentMaster.id}`
          );
          break;
        case "exportExcel":
          response = await postAPI(
            StudentMasterEndpoint.export,
            studentMaster.formValues
          );
          break;
        case "BatchTransfer":
          response = await putAPI(
            `${StudentMasterEndpoint.batchTransfer}?batchId=${
              studentMaster.batchId
            }&${appendQueryStr(studentMaster.studentIds, "studentIds")}`,
            ""
          );
          break;
        case "studentDropdown":
          response = await getAPI(
            `${StudentMasterEndpoint.studentDropdown}?${studentMaster.requestParams}`
          );
          break;
        case "exportPdf":
          response = await getAPI(
            `${StudentMasterEndpoint.exportPdf}${studentMaster.formValues}/download`
          );
          break;
        case "studentListCourseLevelWise":
          response = await getAPI(
            `${StudentMasterEndpoint.studentListCourseLevelWise}${studentMaster.formValues}/levelOfAdmissionId`
          );
          break;
        case "sendOTP":
          response = await postAPI(
            `${StudentMasterEndpoint.sentOtp}?mobileNumber=${studentMaster.mobileNumber}`,
            ""
          );
          break;
        case "verifyOTP":
          response = await postAPI(
            `${StudentMasterEndpoint.verifyOtp}?mobileNumber=${studentMaster.mobileNumber}&otp=${studentMaster.otp}`,
            ""
          );
          break;
        case "verifyMobileNo":
          response = await getAPI(
            `${StudentMasterEndpoint.isExistsMobileNo}${studentMaster.requestParam}`
          );
          break;
      }

      return response;
    } catch (err) {
      return err;
    }
  }
);

const appendQueryStr = (ids: number[], name: string) => {
  let qeryStr = "";
  if (ids && ids.length) {
    for (let i = 0; i < ids.length; i++) {
      if (i === 0) {
        qeryStr += `${name}=${ids[i]}`;
      } else {
        qeryStr += `&${name}=${ids[i]}`;
      }
    }
  }
  return qeryStr;
};

const studentMasterSlice = createSlice({
  name: "studentMaster",
  initialState,
  reducers: {
    addObj: (state) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(studentMasterService.fulfilled, (state, action) => {
      state.studentMasterResponse = action.payload;
    });
    builder.addCase(studentMasterService.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const studentMasterReducer = studentMasterSlice.reducer;
export default studentMasterReducer;
